/* ============================================================
   IMENHOF BLOOM — refine.js
   AJAX-filteren op de collectie- en zoekpagina. Vinkjes, sorteren,
   prijs en filter-pillen verversen alleen het resultaatblok
   (#CollectionResults) in plaats van de hele pagina te herladen.
   Behoudt scrollpositie. Zonder dit script vallen de formulieren
   terug op gewone GET-submits (inline onchange-fallback).
   ============================================================ */
(function () {
  'use strict';
  var container = document.getElementById('CollectionResults');
  if (!container) return;                 // alleen op collectie-/zoekpagina
  var root = document.documentElement;
  root.classList.add('refine-js');        // schakelt de inline-submit fallback uit

  var busy = false;
  var io = null;

  /* ---- URL bouwen uit een filter-/sorteerformulier ---- */
  function urlFromForm(form) {
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function (value, key) {
      if (String(value).trim() !== '') params.append(key, value);
    });
    var qs = params.toString();
    return location.pathname + (qs ? '?' + qs : '');
  }

  /* ---- Verse kaarten direct tonen ----
     theme.js verbergt .reveal-elementen tot ze in beeld scrollen via een
     observer die alleen bij paginalading draait. Na een AJAX-swap moeten
     we de nieuw ingevoegde kaarten zelf zichtbaar zetten, anders staan ze
     er wel maar blijven ze onzichtbaar. */
  function reveal(scope) {
    scope.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
    var grid = scope.querySelector('.product-grid');
    if (grid) Array.prototype.forEach.call(grid.children, function (el) { el.classList.add('is-in'); });
  }

  /* ---- Oneindig laden (herbruikbaar; vervangt de versie in theme.js
          die op [data-infinite] zoekt; deze secties gebruiken [data-coll-more]) ---- */
  function initInfinite() {
    if (io) { io.disconnect(); io = null; }
    var more = container.querySelector('[data-coll-more]');
    if (!more) return;
    var grid = container.querySelector('.product-grid');
    var shownEl = more.querySelector('[data-shown]');
    var nextUrl = more.dataset.nextUrl;
    var loading = false;

    async function loadMore() {
      if (loading || !nextUrl || !grid) return;
      loading = true;
      more.classList.add('is-loading');
      try {
        var r = await fetch(nextUrl);
        var html = await r.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('.product-grid > *').forEach(function (card) {
          card.classList.add('is-in');
          card.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
          grid.appendChild(card);
        });
        var next = doc.querySelector('[data-coll-more]');
        nextUrl = next ? next.dataset.nextUrl : '';
        if (shownEl) shownEl.textContent = grid.children.length;
        if (!nextUrl) more.classList.add('is-done');
      } catch (e) { /* knop blijft staan om opnieuw te proberen */ }
      loading = false;
      more.classList.remove('is-loading');
    }

    var moreBtn = more.querySelector('[data-load-more]');
    if (moreBtn) moreBtn.addEventListener('click', loadMore);
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) loadMore(); });
      }, { rootMargin: '700px 0px' });
      io.observe(more);
    }
  }

  /* ---- Resultaatblok verversen ---- */
  async function apply(url, push, scrollTop) {
    if (busy) return;
    busy = true;
    container.classList.add('is-filtering');
    try {
      var r = await fetch(url, { headers: { 'X-Requested-With': 'fetch' } });
      var html = await r.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('CollectionResults');
      if (!fresh) throw new Error('geen resultaatblok in respons');
      container.innerHTML = fresh.innerHTML;
      reveal(container);                  // verse kaarten direct zichtbaar maken

      // Drawer-filters (staan buiten het resultaatblok) meeverversen
      var freshDrawer = doc.querySelector('#FilterDrawer .filters');
      var curDrawer = document.querySelector('#FilterDrawer .filters');
      if (freshDrawer && curDrawer) curDrawer.innerHTML = freshDrawer.innerHTML;

      // Teller in de hero meeverversen (collectiepagina)
      var freshCount = doc.querySelector('.coll-hero__count');
      var curCount = document.querySelector('.coll-hero__count');
      if (freshCount && curCount) curCount.textContent = freshCount.textContent;

      if (push) history.pushState({ refine: true }, '', url);
      initInfinite();
      if (scrollTop) {
        var top = container.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    } catch (e) {
      window.location.href = url;         // harde fallback bij netwerkfout
    }
    busy = false;
    container.classList.remove('is-filtering');
  }

  /* ---- Live vinken + sorteren (desktop sidebar en sorteerkeuze) ---- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.type !== 'checkbox' && t.tagName !== 'SELECT') return;
    var form = t.closest('form[data-filter-form][data-filter-instant]');
    if (!form) return;
    apply(urlFromForm(form), true, false);
  });

  /* ---- Formulier verzenden (prijs "Toepassen", mobiele drawer) ---- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-filter-form]');
    if (!form) return;
    e.preventDefault();
    var inDrawer = form.closest('.drawer');
    apply(urlFromForm(form), true, !!inDrawer);
    if (inDrawer) {
      var close = inDrawer.querySelector('[data-drawer-close]');
      if (close) close.click();           // hergebruik drawer-sluiting uit theme.js
    }
  });

  /* ---- Pillen wissen, "Wis alles" en actieve-filterlinks ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href]');
    if (!a) return;
    if (!a.closest('#CollectionResults') && !a.closest('#FilterDrawer')) return;
    var dest;
    try { dest = new URL(a.href, location.origin); } catch (_) { return; }
    if (dest.pathname !== location.pathname) return;  // alleen filter-/sorteermutaties, geen productlinks
    e.preventDefault();
    apply(dest.pathname + dest.search, true, false);
    var inDrawer = a.closest('.drawer');
    if (inDrawer && dest.search === '') {
      var close = inDrawer.querySelector('[data-drawer-close]');
      if (close) close.click();
    }
  });

  /* ---- Terug-/vooruitknop ---- */
  window.addEventListener('popstate', function () {
    apply(location.pathname + location.search, false, false);
  });

  /* ---- Eerste paginalading: knop + observer meteen activeren ----
     Zonder deze aanroep werd initInfinite() pas na een filter-/sorteer-
     swap gestart, waardoor "Meer laden" op een verse collectiepagina
     geen klik-handler had en niets deed. */
  initInfinite();
})();
